const reportTypes = [
  { id: 'INVESTOR', name: 'Investor' },
  { id: 'CONTACT', name: 'Contact' },
  { id: 'ADMIN', name: 'Admin' }
];

export { reportTypes };
